import { Box } from 'reflexbox';

import { LearningRouterWithoutSidebar } from 'packages/kakapo-ui-application/pages/learning/pages/LearningRouter';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function Learning() {
	const { t } = useTranslation();

	return (
		<Box flexGrow={1} px={5}>
			<Helmet>
				<title>{t('learning.page.title')}</title>
			</Helmet>
			<LearningRouterWithoutSidebar />
		</Box>
	);
}
